import { render, staticRenderFns } from "./newsletterOS.vue?vue&type=template&id=1cd1b632&scoped=true"
import script from "./newsletterOS.vue?vue&type=script&lang=js"
export * from "./newsletterOS.vue?vue&type=script&lang=js"
import style0 from "./newsletterOS.vue?vue&type=style&index=0&id=1cd1b632&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd1b632",
  null
  
)

export default component.exports